export const PERMISSION_DENIED_ERROR_TEXT = 'Permission denied'
export const PERMISSION_DISMISSED_ERROR_TEXT = 'Permission dismissed'
